import { render, staticRenderFns } from "./ExtraToolHome.vue?vue&type=template&id=dd247354&scoped=true&"
import script from "./ExtraToolHome.vue?vue&type=script&lang=js&"
export * from "./ExtraToolHome.vue?vue&type=script&lang=js&"
import style0 from "./ExtraToolHome.vue?vue&type=style&index=0&id=dd247354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd247354",
  null
  
)

export default component.exports